import { render, staticRenderFns } from "./SummaryCAPEXold.vue?vue&type=template&id=ee274400&"
import script from "./SummaryCAPEXold.vue?vue&type=script&lang=js&"
export * from "./SummaryCAPEXold.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCAPEXold.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VDataTable,VIcon,VOverlay,VProgressCircular})
